<!--
vInput 组件支持 input 原生事件、支持v-model 指令
props字段：
max:输入最大长度 默认50
vClass：自定义样式类 默认 空
errText：错误提示语 默认 空
showLimit：是否显示最大长度 默认 false
labelName 默认 空
disabled: 是否不可填 默认 false
required： 是否显示 * 默认 false
type:[text|password]
placeholder:自定义提示语【默认是：请输入您的+labelName】
---
icon 插槽
name="v-left" //显示左iconfont
name="v-right" //显示左iconfont
例子：
<span slot="v-left" class="iconfont iconact_dianzan_full"></span>
<span slot="v-right" class="iconfont iconact_dianzan_full"></span>
-------
例子：
<v-input vClass="aa" v-model="val" required=true @input="vInput" @change="vChange" @blur="vBlur" :errText="'sdfsdf'" :showLimit="true" labelName="姓名" :disabled="false"></v-input>
-->

<template>
  <div :class="['v-input-box', vClass]">
    <label class="pointer">
      <div class="font-size-14 label">
        <span class="v-input-xing font-size-16" v-if="required">*</span><span v-if="labelName" class="v-label-color">{{ labelName }}</span>
      </div>
      <!--  -->
      <div :class="['v-box flex-start', { 'err-border': errText }, disabled ? 'disabled' : '']">
        <slot name="v-left"></slot>
        <!--   -->
        <!-- <input type="text"/> -->
        <input
          :type="type"
          :placeholder="placeholder ? placeholder : defaultHolder"
          :maxlength="max"
          @blur="eBlur"
          @change="eChange"
          @focus="eFocus"
          @input="eInput"
          :disabled="disabled"
          :class="[disabled ? 'disabled' : '']"
          v-model="val"
        />
        <slot name="v-right"></slot>
        <span class="font-size-12 v-limit" v-if="showLimit">{{ valLength }}/{{ max }}</span>
      </div>
    </label>
    <div class="v-input-err font-size-12">
      {{ errText }}
    </div>
  </div>
</template>
<script>
export default {
  model:{
    prop:'vals',
    event:'aa'
  },
  props: {
    labelName: {
      type: [String],
      default: () => ''
    },
    type: {
      type: [String],
      default: () => 'text'
    },
    placeholder: {
      type: [String],
      default: () => ''
    },
    required: {
      type: [Boolean],
      default: () => false
    },
    max: {
      type: [Number, String],
      default: () => 50
    },
    errText: {
      type: [String],
      default: () => ''
    },
    vClass: {
      type: [String],
      default: () => ''
    },
    showLimit: {
      type: [Boolean],
      default: () => false
    },
    disabled: {
      type: [Boolean],
      default: () => false
    },
    vals: {
      type: [String, Number, Object, Boolean],
      default: () => ''
    }
  },
  
  name: 'vinput',
  components: {},
  computed: {
    valLength() {
      return this.val.length
    }
  },
  data() {
    return {
      val: this.vals,
      stop: 0,
      defaultHolder:
        localStorage.getItem('language') == 'en'
          ? this.$t('placeholder') + ' ' + this.labelName.toLowerCase()
          : this.$t('placeholder') + this.labelName
    }
  },
  watch: {
    vals() {
      this.val = this.vals
    }
  },
  methods: {
    eInput() {
      var _this = this
     
      clearTimeout(this.stop)
      this.stop = setTimeout(() => {
         _this.val=_this.val.trim();
        _this.$emit('aa', _this.val)
      },300)
    },
    eBlur() {
      this.val=this.val.trim();
      this.$emit('blur', this.val)
    },
    eChange() {
      this.val=this.val.trim();
      this.$emit('change', this.val)
    },
    eFocus() {
      this.val=this.val.trim();
      this.$emit('focus', this.val)
    }
  }
}
</script>
<style lang="stylus" scoped>
.v-input-box{
    margin:12px 0;
    input{
        outline:none;
        height:100%;
        width:100%;
        min-height:30px;
        padding:0 8px;
        border:0;
        font-size: 14px;
    }
    .err-border{
        border:1px solid red;
    }
    .v-input-xing{
        color:red;
        vertical-align:middle;
        margin-right :5px;
    }
    .v-input-err{
        color:red;
    }
    .label{
        line-height: 20px;
        margin-bottom :8px;
    }
    .v-limit{
        margin-left:5px;
    }
    .v-box{
        display:inline-block;
        border: 1px solid $color-black-15;
        padding: 0 5px;
        width:100%;
        background:$color-white;
        border-radius: $border-radius;
        .iconfont{
            margin:0;
            vertical-align: middle;
        }
    }
    .v-label-color{
      color:$color-black-65;
    }
    ::placeholder{
      color:$color-black-25;
    }
    .disabled{
      background-color:$color-input-bg-code1;
      border-color:$color-input-border1;
      color:$color-input-color1;
      cursor: not-allowed;
    }
}
.slot{
  .v-box{
    display:flex
    align-items:center;
  }
}
</style>
